/*
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _tool = require("@entrylabs/tool");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2["default"])((0, _getPrototypeOf2["default"])(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
/*
 *
 */
var DEFAULT_LED_SIZE = 5;
Entry.FieldLed2 = /*#__PURE__*/function (_Entry$Field) {
  function FieldLed2(content, blockView, index) {
    var _this;
    (0, _classCallCheck2["default"])(this, FieldLed2);
    _this = _callSuper(this, FieldLed2, [content, blockView, index]);
    _this.props = {
      content: content,
      blockView: blockView,
      index: index
    };
    _this._block = blockView.block;
    _this._blockView = blockView;
    var board = blockView.getBoard();
    _this.box = new Entry.BoxModel();
    _this.svgGroup = null;
    _this._contents = content;
    _this._index = index;
    _this._position = content.position;
    _this._fontSize = content.fontSize || blockView.getSkeleton().fontSize || 10;
    _this._color = content.color || _this._block.getSchema().fontColor || blockView.getSkeleton().color || 'black';
    _this.key = content.key;
    _this.setValue(_this.getValue() || [[0, 0, 0, 0, 0], [0, 9, 0, 9, 0], [0, 0, 0, 0, 0], [9, 0, 0, 0, 9], [0, 9, 9, 9, 0]]);
    _this.ledSize = _this.getValue().length || DEFAULT_LED_SIZE;
    /*
     */
    _this._CONTENT_HEIGHT = 20;
    _this._CONTENT_WIDTH = _this.getContentWidth();
    _this.renderStart();
    return _this;
  }
  (0, _inherits2["default"])(FieldLed2, _Entry$Field);
  return (0, _createClass2["default"])(FieldLed2, [{
    key: "renderLed",
    value: function renderLed() {
      var _this2 = this;
      var ledStatus = this.getValue();
      var ledDist = 3 * (DEFAULT_LED_SIZE / this.ledSize);
      var ledOffset = 0.5 * (DEFAULT_LED_SIZE / this.ledSize);
      var currentStatus = ledStatus.params || ledStatus;
      currentStatus.map(function (leds, x_pos) {
        return leds.map(function (led, y_pos) {
          if (_this2._rect["".concat(x_pos)]["".concat(y_pos)]) {
            _this2._rect["".concat(x_pos)]["".concat(y_pos)].remove();
          }
          return _this2._rect["".concat(x_pos)]["".concat(y_pos)] = _this2.svgGroup.elem('rect', {
            x: y_pos * ledDist + 4,
            y: x_pos * ledDist - 8 + ledOffset,
            width: ledDist - ledOffset,
            height: ledDist - ledOffset,
            rx: 0.5,
            ry: 0.5,
            fill: currentStatus[x_pos][y_pos] ? '#ffffff' : '#00b6b1'
          });
        });
      });
    }
  }, {
    key: "renderStart",
    value: function renderStart() {
      var blockView = this._blockView;
      var X_PADDING = 20;
      var X_PADDING_SUBT = 10;
      var that = this;
      var CONTENT_HEIGHT = this._CONTENT_HEIGHT;
      var arrowInfo = this.getArrow();
      if (this.svgGroup) {
        $(this.svgGroup).remove();
      }
      var _this$_blockView = this._blockView,
        contentSvgGroup = _this$_blockView.contentSvgGroup,
        renderMode = _this$_blockView.renderMode;
      this.svgGroup = contentSvgGroup.elem('g', {
        "class": 'entry-field-microbit-led'
      });
      var x, y, WIDTH, HEIGHT;
      HEIGHT = this._CONTENT_HEIGHT;
      WIDTH = this._CONTENT_WIDTH + 10;
      var position = this._position;
      if (position) {
        x = position.x || 0;
        y = position.y || 0;
      } else {
        x = 0;
        y = -HEIGHT / 2;
      }
      this._header = this.svgGroup.elem('rect', {
        x: x,
        y: y,
        width: 35,
        //WIDTH,
        height: 20,
        //HEIGHT,

        rx: 2,
        ry: 2,
        fill: '#008380'
      });
      this._rect = Array.from({
        length: this.ledSize
      }, function () {
        return [];
      });
      this.renderLed();
      this._arrow = this.svgGroup.elem('path', {
        d: "M 30.79 -1.182\n            L 28.339 1.8\n            a 0.5 0.5 0 0 1 -0.772 0\n            L 25.114 -1.182\n            A 0.5 0.5 0 0 1 25.5 -2\n            h 4.904\n            a 0.5 0.5 0 0 1 0.387 0.818\n            z\n            ",
        fill: arrowInfo.color,
        stroke: arrowInfo.color
      });
      this._bindRenderOptions();
      this.box.set({
        x: x,
        y: y,
        width: WIDTH,
        height: HEIGHT
      });
    }
  }, {
    key: "getArrow",
    value: function getArrow() {
      return {
        color: '#ffffff',
        points: '0,0 6.4,0 3.2,4.2',
        height: 4.2,
        width: 6.4
      };
    }
  }, {
    key: "_attachDisposeEvent",
    value: function _attachDisposeEvent(func) {
      var _this3 = this;
      var action = func;
      if (!action) {
        action = function action(skipCommand) {
          _this3.destroyOption(skipCommand);
          _this3._selectBlockView();
        };
      }
      this.disposeEvent = Entry.disposeEvent.attach(this, action);
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this4 = this;
      this.optionGroup = Entry.Dom('div', {
        "class": 'entry-field-microbit-led',
        parent: $('body')
      });
      this.ledPicker = new _tool.LedPicker({
        data: {
          eventTypes: ['mousedown', 'touchstart'],
          ledStatus: this.getValue(),
          canTransparent: false,
          positionDom: this.svgGroup,
          onOutsideClick: function onOutsideClick(ledMatrix) {
            if (_this4.ledPicker) {
              _this4.ledPicker.hide();
              ledMatrix && _this4.applyValue(ledMatrix);
            }
            _this4._attachDisposeEvent();
          },
          withLevel: true
        },
        container: this.optionGroup[0]
      }).on('change', function (value) {
        if (value) {
          _this4.applyValue(value);
        }
      });
      this.optionDomCreated();
    }
  }, {
    key: "applyValue",
    value: function applyValue(value) {
      this.setValue(value);
      this.renderLed();
    }
  }, {
    key: "destroyOption",
    value: function destroyOption() {
      if (this.ledPicker) {
        this.ledPicker.isShow && this.ledPicker.hide();
        this.ledPicker.remove();
        this.ledPicker = null;
      }
      if (this.optionGroup) {
        this.optionGroup.remove();
      }
      _superPropGet(FieldLed2, "destroyOption", this, 3)([]);
    }
  }, {
    key: "getContentWidth",
    value: function getContentWidth() {
      return 22;
    }
  }]);
}(Entry.Field);